import '@babel/polyfill'
import 'es6-promise/auto'
import lodash from 'lodash'
// import VueLodash from 'vue-lodash'
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'

import VModal from 'vue-js-modal'
import axios from 'axios'
import smoothscroll from 'smoothscroll-polyfill'
import './registerServiceWorker'
import InfiniteLoading from 'vue-infinite-loading'
import DsLog from 'DsWebLogSender'
import router from './config/router'
import App from './App.vue'
// import store from './store'

import Filters from '../plugins/filter'
import nativeJSInterfaceBridge from '../plugins/nativeJSInterfaceBridge'
import Common from '../plugins/common'
import AppLog from '../plugins/appLog'

// =================================================
// V2

import AppManager from '@/plugins/AppManager'
import AppLogManager from '@/plugins/AppLogManager'
import NativeStorageManager from '@/plugins/NativeStorageManager'
import store from './store'

Vue.prototype.$appManager = new AppManager()
Vue.prototype.$appLogManager = new AppLogManager()
Vue.prototype.$nativeStorageManager = new NativeStorageManager()

// =================================================

const VueMomentLib = require('vue-moment-lib').default

smoothscroll.polyfill()
window.__forceSmoothScrollPolyfill__ = true

Vue.use(VueCompositionApi)
Vue.use(Filters)
Vue.use(nativeJSInterfaceBridge(getNativeData))
Vue.use(InfiniteLoading, {
  /* options */
})
Vue.use(VueMomentLib)
Vue.use(Common)
Vue.use(AppLog)

Vue.use(VModal, {
  dialog: true
})

DsLog.init({
  table: 'weblog-common',
  env: process.env.VUE_APP_APP_LOG_ENV,
  field: {
    screenName: '',
    group: '',
    service: 'baemin-market'
  }
})

const http = axios.create({
  baseURL: process.env.VUE_APP_PROXY_API_URL
})

const http2 = axios.create({
  baseURL: process.env.VUE_APP_PROXY_API_URL_2
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response === undefined || error.response === null) {
      error.response = {
        data: {
          result: process.env.VUE_APP_COMMON_ERROR_MESSAGE
        }
      }
    }

    return Promise.reject(error)
  }
)

http2.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response === undefined || error.response === null) {
      error.response = {
        data: {
          result: process.env.VUE_APP_COMMON_ERROR_MESSAGE
        }
      }
    }

    return Promise.reject(error)
  }
)

global.http = http
global.http2 = http2
Vue.prototype.$http = http
Vue.prototype.$http2 = http2
Vue.prototype._ = lodash

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
